import * as React from "react";
import { Button } from "@mui/material";
import { BorrowerChild } from "@tlc/ls2pac/dto/BorrowerChild";
import { useLanguage } from "@tlc/ls2pac/components/Language";
import { ChildSelectionDialog } from "./ChildSelectionDialog";
import { useDialog } from "@tlc/ui/dialog/useDialog";

interface AssociatedStudentsProps {
  listId: number;
  students: BorrowerChild[];
  childIds: BorrowerChild["id"][];
}

export const AssociatedStudents: React.FC<AssociatedStudentsProps> = ({
  childIds: initialChildIds,
  students,
  listId,
}) => {
  const { translate } = useLanguage();
  const { dialogProps, openDialog, closeDialog } = useDialog();
  const [childIds, setChildIds] = React.useState(initialChildIds || []);

  const associatedStudents = React.useMemo(() => {
    const childNames = students
      .filter((child) => childIds.includes(child.id))
      .map((child) => `${child.firstName} ${child.lastName}`)
      .sort();
    if (childNames.length === 0) {
      return "None"; // TODO translate
    }

    if (childNames.length === 1) {
      return childNames[0];
    }

    if (childNames.length === 2) {
      return childNames.join(" and "); // TODO translate
    }

    return `${childNames.slice(0, -1).join(", ")}, and ${
      childNames[childIds.length - 1]
    }`;
  }, [childIds]);

  return (
    <>
      {translate("associatedStudents")}: {associatedStudents}
      <Button onClick={() => openDialog()}>{translate("edit")}</Button>
      <ChildSelectionDialog
        {...dialogProps}
        onSave={(updatedChildIds) => {
          closeDialog();
          setChildIds(updatedChildIds);
        }}
        students={students}
        listId={listId}
        childIds={childIds}
      ></ChildSelectionDialog>
    </>
  );
};
